// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class JournalCoverageDetailsService {
   $almaLanguages: any
   $filter: any
   constructor($filter: any,$almaLanguages: any) {
      this.getJournalCoverageSummary = this.getJournalCoverageSummary.bind(this)
      this.getJournalConverageDetailEJournalLink = this.getJournalConverageDetailEJournalLink.bind(this)
      this.getJournalConverageDetailEJournalLinkSOA = this.getJournalConverageDetailEJournalLinkSOA.bind(this)
      this.discoverTotalRangeAndItsGaps = this.discoverTotalRangeAndItsGaps.bind(this)
      this.isConsecutiveCoverage = this.isConsecutiveCoverage.bind(this)
      this.isJournalCoverageAvailable = this.isJournalCoverageAvailable.bind(this)
      this.$filter = $filter
      this.$almaLanguages = $almaLanguages
   }

   getJournalCoverageSummary(doc: any) {
    
      if (!doc.journal_database_rights?.length) {
         return null
      }
      doc.journal_database_rights = doc.journal_database_rights.filter(
         (right: any) => (right.provider_name !== 'Library Specific Holdings'))
      const orderedRights = this.$filter('orderBy')(doc.journal_database_rights, "date_start")
      return this.discoverTotalRangeAndItsGaps(orderedRights)
   }

   getJournalConverageDetailEJournalLink(libHash: any,issn: any)  {
  
      const eJournalLink = `http://${libHash}.search.serialssolutions.com/ejp/?libHash=${libHash}#/search/?searchControl=title&searchType=issn_equals&criteria=${issn}&titleType=JOURNALS&filterBy=All&beginPage=0&language=en-US` 
      return eJournalLink
   }

   getJournalConverageDetailEJournalLinkSOA(almaBaseUrl: any,almaInstitutionCode: any,ieId: any) {
      if (!(almaBaseUrl && almaInstitutionCode && ieId)) {
         return null
      }
      let languageParamString = ""
      // @ts-expect-error TS(2339) FIXME: Property '__locale' does not exist on type 'Window... Remove this comment to see the full error message
      const language = window.__locale.substring(0,2).toUpperCase()
      
      const almaLanguage = this.$almaLanguages[language]
      if (almaLanguage) {
         languageParamString = `,language=${almaLanguage}`
      } else {
         languageParamString =",language=en"
      }
      const eJournalLinkSOA = `http://${almaBaseUrl}/discovery/openurl?institution=${almaInstitutionCode}&rfr_id=info:sid/summon&rft_dat=ie=${ieId}${languageParamString}&svc_dat=CTO&u.ignore_date_coverage=true&vid=${almaInstitutionCode}:Services`
      return eJournalLinkSOA
   }

   // Rights must be ordered by start date for this function to work
   discoverTotalRangeAndItsGaps(orderedRights: any) {
      if (!orderedRights?.length) { return {} }
      let nonContiguousRange = { 
         start: 99991231, // high default min start will be replaced in first iteration  
         end: 0 // low default max end will be replaced in first iteration
      }
      const gaps: any = []
      let contiguousRangeEnd = 0

      const timestampPattern = new RegExp(`^(0|[1-9][0-9]*)$`)
      let atLeastOneIteration = false
      _.each(orderedRights, (right: any) => {
         if (!right.date_start?.match(timestampPattern) || !right.date_end?.match(timestampPattern)) {
            return
         }
         const currRange = { 
            start : +right.date_start,
            end : +right.date_end
         }
        
         nonContiguousRange = { 
            start: Math.min(currRange.start, nonContiguousRange.start),
            end: Math.max(currRange.end, nonContiguousRange.end)
         }
        
         if ((currRange.start > contiguousRangeEnd) && atLeastOneIteration && !this.isConsecutiveCoverage(currRange.start, contiguousRangeEnd)) {
            gaps.push({ start : contiguousRangeEnd, end : currRange.start })
            contiguousRangeEnd = currRange.end
         } else {
            contiguousRangeEnd = Math.max(currRange.end, contiguousRangeEnd)
         }
        
         return atLeastOneIteration = true
      })

      if (!atLeastOneIteration) {
         return {}
      }
      return { range : nonContiguousRange, gaps }
   }

   // coverage gap is less than or equal to one day
   isConsecutiveCoverage(timestampOne: any, timestampTwo: any) {
      if ((timestampOne <= timestampTwo) || (timestampOne == null) || (timestampTwo == null)) {
         return false
      }

      const tsStringOne = timestampOne.toString()
      const tsStringTwo = timestampTwo.toString()
      const dateOne = new Date(tsStringOne.substring(0,4), tsStringOne.substring(4,6) - 1, tsStringOne.substring(6,8))
      const dateTwo = new Date(tsStringTwo.substring(0,4), tsStringTwo.substring(4,6) - 1, tsStringTwo.substring(6,8))
      const difference =  dateOne.getTime() - dateTwo.getTime()
      const daysDifference = Math.floor(difference/1000/60/60/24)

      return daysDifference <= 1
   }

   isJournalCoverageAvailable(doc: any) {
      if (!_.includes(['Journal', 'eJournal'], (doc.content_type))) {
         return false
      }
    
      return doc.journal_database_rights?.length
   }
}

JournalCoverageDetailsService.$inject = ['documentService','$filter','$almaLanguages']

angular.module('summonApp.services')
   .service('journalCoverageDetailsService', ['$filter','$almaLanguages', JournalCoverageDetailsService])
